import { DEFAULT_CHAIN_ID } from '@ui/constants/chain';
import { injected } from 'wagmi/connectors';

// Using a placeholder icon URL for now as local asset is missing
const binanceIcon = 'https://bin.bnbstatic.com/static/images/common/favicon.ico';

const getDeepLink = (url: string, chainId = 1) => {
    const base = 'bnc://app.binance.com/mp/app'
    const appId = 'yFK5FCqYprrXDiVFbhyRx7'

    const startPagePath = window.btoa('/pages/browser/index')
    const startPageQuery = window.btoa(`url=${url}&defaultChainId=${chainId}`)
    const deeplink = `${base}?appId=${appId}&startPagePath=${startPagePath}&startPageQuery=${startPageQuery}`
    const dp = window.btoa(deeplink)
    const http = `https://app.binance.com/en/download?_dp=${dp}`
    
return { http, bnc: deeplink }
}

export const binanceConnector = () => {
    const c = injected({
        target: { // Provide the injected target to avoid window.ethereum provider overwrite conflict
            id: 'com.binance.wallet',
            name: 'Binance Wallet Injected',

            // @ts-ignore
            provider: () => window?.binancew3w?.ethereum || window?.ethereum,
        },
        // @ts-ignore
        shimDisconnect: true,
    });

    return (ctx: any) => {
        const connector = c(ctx);

        return {
            ...connector,
            getProvider: () => connector.getProvider(),
            id: 'com.binance.wallet',
            name: 'Binance Web3',
            icon: binanceIcon,
            getWalletConnectDeeplink: null,
            getQrCode: () => null,
            // @ts-ignore
            isAuthorized: async () => {
                if (typeof window !== 'undefined' && !(window as any).binancew3w) {
                    return false;
                }

                return connector.isAuthorized();
            },
            get installed() {
                return typeof window !== 'undefined' && !!(window as any).binancew3w;
            },
            get suggested() {
                return false;
            },
            extension: {
                instructions: {
                    learnMoreUrl: 'https://www.binance.com/en/web3wallet',
                    steps: [],
                },
            },
            downloadUrls: {
                get download() {
                    if (typeof window === 'undefined')
                        return 'https://www.binance.com/en/web3wallet';

                    const isMobile = /iPhone|iPad|iPod|Android/i.test(
                        window.navigator.userAgent,
                    );

                    if (isMobile) {
                        return getDeepLink(window.location.href, DEFAULT_CHAIN_ID).http;
                    }
                    
return 'https://www.binance.com/en/web3wallet';
                },
            },
        };
    };
};
